/**
 * 登录 Cookie 管理
 *
 * @create 2022-03-08
 */
import { cookie, storage } from '@tencent/webibi-compat';
import { IsTest } from './tools';

export const LOGIN_KEY = 'wand_intel_login_info';
const WAND_OPENID = 'openid';
const IsHttp = location.protocol === 'http:';
const ActivityName = 'Invite';
const WAND_COOKIE_PRE = `Wand_${ActivityName}`;
// 需要写入的cookie
export const WAND_COOKIE = [
  WAND_OPENID,
  'token',
  'game_id',
  'gameid',
  'channel',
  'encodeparam',
  'role_id',
  'zone_id',
  'area_id',
  'plat_id',
];
export const WAND_STORE = ['email', 'user_name'];

type a<T> = {
  keys: keyof T;
};

/**
 * 获取登录态
 */
export function getLoginCookie() {
  const cookies = WAND_COOKIE.reduce((data: Record<string, string>, key) => {
    const wandKey = `${WAND_COOKIE_PRE}_${key}`;
    const val = cookie.get(wandKey);
    if (val) {
      data[key] = val;
    }
    return data;
  }, {});
  return {
    ...cookies,
  };
}

/**
 * 设置登录态
 */
export function setLoginCookie(data: Record<string, string | number>) {
  const options = {
    secure: true,
    expires: new Date(data.expires),
    path: '/',
  };

  const store: Record<string, string | number> = {
    [WAND_OPENID]: data[WAND_OPENID],
  };
  //  登录相关cookie
  Object.keys(data).forEach((key) => {
    const val = data[key];
    if (WAND_COOKIE.indexOf(key) === -1) {
      return;
    }
    const wandKey = `${WAND_COOKIE_PRE}_${key}`;
    if (IsHttp && IsTest) {
      const stringS = `${wandKey}=${val}`;
      document.cookie = stringS;
    } else {
      cookie.set(wandKey, val, options);
    }
  });
  setLoginInfo(data);
}

/**
 * 清除登录态
 */
export function clearLoginCookie() {
  WAND_COOKIE.forEach((key) => {
    if (key === 'lang_type') return;
    const wandKey = `${WAND_COOKIE_PRE}_${key}`;
    if (IsHttp && IsTest) {
      const stringS = `${wandKey}=; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
      document.cookie = stringS;
    } else {
      cookie.remove(wandKey);
    }
  });

  cleanLoginInfo();
}

/**
 * 缓存登录信息
 */
function setLoginInfo(data: Record<string, string | number>) {
  const store: Record<string, string | number> = {
    [WAND_OPENID]: data[WAND_OPENID],
  };
  Object.keys(data).forEach((key) => {
    const val = data[key];

    if (WAND_STORE.indexOf(key) !== -1) {
      store[key] = val;
      return;
    }
  });
  storage.set(LOGIN_KEY, {
    ...store,
  });
}

/**
 * 清除登录信息
 */
function cleanLoginInfo() {
  storage.remove(LOGIN_KEY);
}

export function getLoginInfo() {
  return storage.get(LOGIN_KEY);
}
